import DocumentationContainer from "../../container/admin/documentation-container";

const DocumentationManager = () => {
    return <DocumentationContainer />;
};

export default DocumentationManager;
